/**
 * @generated SignedSource<<4e45a8049ba3741705dfe3b5f74e05c1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getAttributeInfo_itemAttributes$data = {
  readonly customizable: ReadonlyArray<{
    readonly option: {
      readonly serviceId: string | null;
    } | null;
    readonly text: string | null;
  } | null> | null;
  readonly ringResizable: ReadonlyArray<{
    readonly option: {
      readonly serviceId: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "getAttributeInfo_itemAttributes";
};
export type getAttributeInfo_itemAttributes$key = {
  readonly " $data"?: getAttributeInfo_itemAttributes$data;
  readonly " $fragmentSpreads": FragmentRefs<"getAttributeInfo_itemAttributes">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getAttributeInfo_itemAttributes"
};

(node as any).hash = "5e5b7fe4a0877f1a0cc463017a86e65c";

export default node;
